import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ComboTipoConteudoRimComponent} from './combo-tipo-conteudo-rim.component';
import {MaterialCommonModule} from 'src/app/material-modules/material-common.module';
import {MatExpansionModule} from '@angular/material/expansion';
import {ComboPesquisavelModule} from '../combo-pesquisavel/combo-pesquisavel.module';


@NgModule({
    declarations: [ComboTipoConteudoRimComponent],
    imports: [
        CommonModule,
        MaterialCommonModule,
        MatExpansionModule,
        ComboPesquisavelModule
    ],
    exports: [ComboTipoConteudoRimComponent]
})
export class ComboTipoConteudoRimModule {
}
